import classnames from 'classnames'
import {Browser} from '@clappr/core'
import styles from './styles.scss'

interface Button {
  social?: boolean
  value: string
  text: string
  color?: string
  svgPath: string
}

const BUTTONS: Button[] = [
  {
    social: true,
    value: 'vk',
    text: 'VK',
    color: '#2787f5',
    svgPath:
      '<path d="M20 0v20M0 20V0m19.53 4.87c.15-.46 0-.8-.66-.8h-2.18a1 1 0 0 0-1 .61A18.53 18.53 0 0 1 13 9.15c-.51.51-.74.68-1 .68s-.34-.17-.34-.63V4.85c0-.55-.17-.8-.63-.8h-3.4a.53.53 0 0 0-.56.51c0 .53.79.65.87 2.14v3.22c0 .69-.12.82-.4.82C6.8 10.74 5 8 3.92 4.9c-.21-.62-.43-.85-1-.85H.74c-.63 0-.74.29-.74.61 0 .57.74 3.45 3.45 7.27a8.52 8.52 0 0 0 6.67 4c1.4 0 1.57-.32 1.57-.85v-2c0-.63.13-.74.57-.74s.89.17 2.19 1.42C15.93 15.27 16.18 16 17 16h2.18c.64 0 .93-.32.76-.93a9.51 9.51 0 0 0-1.84-2.56c-.51-.6-1.27-1.25-1.5-1.57s-.24-.59 0-1c0 0 2.64-3.78 2.92-5" />'
  },
  // {
  //   social: true,
  //   value: 'facebook',
  //   text: 'Facebook',
  //   color: '#1877f2',
  //   svgPath:
  //     '<path d="M20 0v20M0 20V0m19 9.5a9 9 0 1 0-10.41 8.89V12.1H6.31V9.5h2.28v-2A3.18 3.18 0 0 1 12 4a14.32 14.32 0 0 1 2 .17v2.24h-1.13a1.29 1.29 0 0 0-1.46 1.4V9.5h2.49l-.4 2.6h-2.09v6.29A9 9 0 0 0 19 9.5Z" />'
  // },
  {
    social: true,
    value: 'ok',
    text: 'ОК',
    color: '#ee8208',
    svgPath:
      '<path d="M13.1367 8.6164C12.3341 9.4246 11.2304 9.92533 10.0046 9.92533C8.78321 9.92533 7.6752 9.42021 6.87255 8.6164C6.06989 7.8082 5.5726 6.69693 5.5726 5.46266C5.5726 4.2284 6.07425 3.11713 6.87255 2.30893C7.67084 1.50073 8.77885 1 10.0046 1C11.2261 1 12.3341 1.50512 13.1367 2.30893C13.9394 3.11713 14.4367 4.2284 14.4367 5.46266C14.4367 6.69693 13.935 7.8082 13.1367 8.6164ZM10.0046 3.4246C9.45063 3.4246 8.95334 3.64861 8.58255 4.02196C8.21612 4.39092 7.98928 4.89605 7.98928 5.45388C7.98928 6.01171 8.21176 6.51244 8.58255 6.8858C8.94898 7.25476 9.45063 7.48316 10.0046 7.48316C10.5586 7.48316 11.0559 7.25915 11.4267 6.8858C11.7932 6.51684 12.02 6.01171 12.02 5.45388C12.02 4.89605 11.7975 4.39532 11.4267 4.02196C11.0559 3.66179 10.5586 3.4246 10.0046 3.4246ZM14.6592 9.9429L15.9591 11.7306C16.0245 11.8228 16.0115 11.9414 15.9198 12.0073C14.8293 12.9078 13.5511 13.5051 12.225 13.8214L14.7377 18.6969C14.8031 18.8419 14.7115 19 14.5545 19H11.8717C11.7932 19 11.7146 18.9473 11.6754 18.8682L10.0046 14.8404L8.32081 18.8551C8.29464 18.9341 8.21612 18.9868 8.12451 18.9868H5.44173C5.28469 18.9868 5.19308 18.8155 5.25851 18.6837L7.77117 13.8214C6.44068 13.5051 5.17999 12.9078 4.07635 12.0073C3.99783 11.9414 3.97165 11.8097 4.03709 11.7306L5.33704 9.9429C5.41556 9.83748 5.54642 9.8243 5.63803 9.90337C6.85946 10.9488 8.37316 11.6384 9.99155 11.6384C11.6099 11.6384 13.1106 10.9619 14.3451 9.90337C14.4498 9.81991 14.5937 9.83309 14.6592 9.9429Z" />'
  },
  // {
  //   social: true,
  //   value: 'twitter',
  //   text: 'Twitter',
  //   color: '#1d9bf0',
  //   svgPath:
  //     '<path d="M20 0v20M0 20V0m6.29 18.13A11.59 11.59 0 0 0 18 6.45v-.53a8.43 8.43 0 0 0 2-2.12 8.49 8.49 0 0 1-2.36.64 4.1 4.1 0 0 0 1.81-2.27 8.17 8.17 0 0 1-2.61 1 4.1 4.1 0 0 0-7 3.74 11.64 11.64 0 0 1-8.45-4.29 4.16 4.16 0 0 0-.55 2.07A4.09 4.09 0 0 0 2.66 8.1 4.07 4.07 0 0 1 .8 7.59a4.1 4.1 0 0 0 3.29 4 3.81 3.81 0 0 1-1.09.22 3.94 3.94 0 0 1-.77-.08 4.11 4.11 0 0 0 3.84 2.85A8.27 8.27 0 0 1 1 16.34a7.93 7.93 0 0 1-1-.06 11.57 11.57 0 0 0 6.29 1.85" />'
  // },
  {
    social: true,
    value: 'lj-embed',
    text: 'LJ',
    color: '#ffffff',
    svgPath: [
      '<path fill="#00B0EA" d="M10 1.2a8.9 8.9 0 0 0-3.4.8l-2-2A9 9 0 0 0 0 4.6l2 2a8.8 8.8 0 0 0-.8 3.5 8.9 8.9 0 0 0 8.9 8.9 8.9 8.9 0 0 0 8.9-8.9c0-4.9-4-8.9-9-8.9"/>',
      '<path fill="#15374C" d="M14.3 11.6a5.2 5.2 0 0 0-2.7 2.7l3.4.7-.7-3.4zm-5.1 2.2a9 9 0 0 1 4.6-4.6L6.6 2A9 9 0 0 0 2 6.6l7.2 7.2z"/>',
      '<path fill="#FFF" d="m14.3 11.6-.5-2.4a9 9 0 0 0-4.6 4.6l2.4.5a5.2 5.2 0 0 1 2.7-2.7"/>'
    ].join('')
  },
  {
    value: 'link',
    text: Browser.isMobile ? '<%= share_link %>' : '<%= share_copy_link %>',
    svgPath:
      '<path d="M20 0v20M0 20V0m14 11.68-.43.44a5 5 0 0 1-2.82 1.4l-2.16 2.14a2 2 0 0 1-2.83-2.83L8.59 10a2 2 0 0 1 1.92-.51L12 8a4 4 0 0 0-4.85.61l-2.81 2.8A4 4 0 0 0 10 17.07l2.83-2.83A4 4 0 0 0 14 11.68Zm1.69-3.09-2.83 2.82A4 4 0 0 1 8 12l1.51-1.51a2 2 0 0 0 1.9-.49l2.83-2.83a2 2 0 0 0-2.83-2.83L9.27 6.49a4.94 4.94 0 0 0-2.81 1.39L6 8.32a4 4 0 0 1 1.17-2.56L10 2.93a4 4 0 0 1 5.66 5.66Z" />'
  },
  {
    value: 'code',
    text: Browser.isMobile ? '<%= share_code %>' : '<%= share_copy_code %>',
    svgPath:
      '<path d="M6.895 17.888l7.553-15.106c.123-.247.023-.547-.224-.67l-.447-.224c-.247-.124-.548-.023-.671.224L5.553 17.217c-.123.247-.023.547.224.671l.447.224c.247.123.548.023.671-.224M0 20V0m20 0v20M5.844 14.195l.313-.39c.172-.216.137-.531-.078-.703L2.201 10l3.878-3.102c.215-.173.25-.488.078-.703l-.313-.391c-.172-.215-.487-.25-.703-.077L.532 9.414c-.375.3-.375.871 0 1.171l4.609 3.688c.216.172.531.138.703-.078m8.313 0l-.313-.39c-.172-.216-.137-.531.078-.703L17.8 10l-3.878-3.102c-.215-.173-.25-.488-.078-.703l.313-.391c.172-.215.487-.25.703-.077l4.609 3.687c.375.3.375.871 0 1.171l-4.609 3.688c-.216.172-.531.138-.703-.078" />'
  }
]

const getButton = (config: Button): string => {
  const style = config.color ? `style="background: ${config.color}"` : ''
  const attribute = config.social ? `data-share-network` : `data-share-embed`

  return `<div class="${styles.button}" ${attribute}="${config.value}">
    <div
      class="${classnames(
        config.social && styles.buttonSocialIcon,
        styles.buttonIcon
      )}"
      ${style}
    >
      <svg viewBox="0 0 20 20">
        ${config.svgPath}
      </svg>
    </div>
    <div class="${styles.buttonText}">${config.text}</div>
  </div>`
}

const MAX_BUTTONS = 2

const RESULT_LIST =
  BUTTONS.length > MAX_BUTTONS ? BUTTONS.slice(0, -MAX_BUTTONS) : BUTTONS

const LIST_TAIL =
  BUTTONS.length > MAX_BUTTONS
    ? `<div class="${styles.listTail}">
  ${BUTTONS.slice(-MAX_BUTTONS).map(getButton).join('')}
</div>`
    : ''

export default `<div
  class="${styles.root} eplayer-skin-component eplayer-skin-fullsize"
  style="display: none"
>
  <div class="${styles.close}" data-share-close>
    <svg
      class="${styles.closeIcon}"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
    >
    <path
      fill-rule="evenodd"
      d="M0 20V0m20 0v20M16.18 4.88 11.06 10l5.12 5.12a.5.5 0 0 1 0 .7l-.36.36a.5.5 0 0 1-.7 0L10 11.06l-5.12 5.12a.5.5 0 0 1-.7 0l-.36-.36a.5.5 0 0 1 0-.7L8.94 10 3.82 4.88a.5.5 0 0 1 0-.7l.36-.36a.5.5 0 0 1 .7 0L10 8.94l5.12-5.12a.5.5 0 0 1 .7 0l.36.36a.5.5 0 0 1 0 .7"
    />
    </svg>
  </div>
  <div class="${styles.popup}" data-share-content>
    <div class="${styles.title}"><%= share %></div>
    <div class="${styles.list}">
      ${RESULT_LIST.map(getButton).join('')}
      ${LIST_TAIL}
    </div>
  </div>
</div>`
